import config from "./config";
var axios = config();

export default {
  getWorkloadTypeDefinitions() {
    return axios.get("/api/Workloads/GetWorkloadTypeDefinitions");
  },

  getApprovedWorkloads(filters, page, pageSize, sortBy, sortDesc) {
    var filter = "";

    // if (filters.search) {
    //   filter += "&search=" + filters.search;
    // }
    if (page) {
      filter += "&pageNumber=" + page;
    }
    if (pageSize) {
      filter += "&pageSize=" + pageSize;
    }

    if (sortBy) {
      filter += "&sortBy=" + sortBy + "&sortDesc=" + sortDesc;
    }

    _.forEach(_.keys(filters), key => {
      if (filters[key]) {
        filter += "&" + key + "=" + filters[key];
      }
    });

    return axios.get("/api/Workloads/GetApprovedWorkloads?" + filter);
  },

  getDeniedWorkloads(filters, page, pageSize, sortBy, sortDesc) {
    var filter = "";

    // if (filters.search) {
    //   filter += "&search=" + filters.search;
    // }
    if (page) {
      filter += "&pageNumber=" + page;
    }
    if (pageSize) {
      filter += "&pageSize=" + pageSize;
    }

    if (sortBy) {
      filter += "&sortBy=" + sortBy + "&sortDesc=" + sortDesc;
    }

    _.forEach(_.keys(filters), key => {
      if (filters[key]) {
        filter += "&" + key + "=" + filters[key];
      }
    });
    return axios.get("/api/Workloads/GetDeniedWorkloads?" + filter);
  },

  getPendingWorkloads(filters, page, pageSize, sortBy, sortDesc) {
    var filter = "";

    // if (filters.search) {
    //   filter += "&search=" + filters.search;
    // }
    if (page) {
      filter += "&pageNumber=" + page;
    }
    if (pageSize) {
      filter += "&pageSize=" + pageSize;
    }

    if (sortBy) {
      filter += "&sortBy=" + sortBy + "&sortDesc=" + sortDesc;
    }

    _.forEach(_.keys(filters), key => {
      if (filters[key]) {
        filter += "&" + key + "=" + filters[key];
      }
    });

    return axios.get("/api/Workloads/GetPendingWorkloads?" + filter);
  },

  getWorkloadById(workloadId) {
    return axios.get("/api/Workloads/GetWorkloadById/" + workloadId);
  },

  getAllWorkloadsByAsurite(asuriteId) {
    return axios.get("/api/Workloads/GetAllWorkloadsByAsurite/" + asuriteId);
  },

  getWorkloadHistory(asurite, timePeriodId) {
    return axios.get(
      "/api/Workloads/GetWorkloadHistory/" +
      asurite +
      (timePeriodId ? "/" + timePeriodId : "")
    );
  },

  getApprovedWorkloadsByAsurite(asuriteId) {
    return axios.get(
      "/api/Workloads/GetApprovedWorkloadsByAsurite/" + asuriteId
    );
  },

  getUnapprovedWorkloadsByAsurite(asuriteId) {
    return axios.get(
      "/api/Workloads/GetUnapprovedWorkloadsByAsurite/" + asuriteId
    );
  },

  getLastWorkload(asuriteId) {
    return axios.get("/api/Workloads/GetLastWorkload/" + asuriteId);
  },

  getWorkloadByTimePeriod(timePeriodId) {
    return axios.get("/api/Workloads/GetWorkloadByTimePeriod/" + timePeriodId);
  },

  // post
  postWorkload(workload) {
    return axios.post("/api/Workloads/AddWorkload", workload);
  },

  postWorkloadFiles(workloadId, files) {
    return axios.post("/api/Workloads/" + workloadId + "/files", files);
  },

  createWorkloadSubmittedEmail(workloadId) {
    return axios.post(
      "/api/Workloads/CreateWorkloadSubmittedEmail/" + workloadId
    );
  },

  createWorkloadSubmittedBehalfEmail(workloadId) {
    return axios.post(
      "/api/Workloads/CreateWorkloadSubmittedOnBehalfEmail/" + workloadId
    );
  },

  createRevisionEmail(workloadId) {
    return axios.post("/api/Workloads/CreateRevisionEmail/" + workloadId);
  },

  approveWorkload(workloadId, notes) {
    return axios.post("/api/Workloads/ApproveWorkload", {
      workloadId: workloadId,
      notes: notes
    });
  },

  createApproveWorkloadEmail(workloadId) {
    return axios.post(
      "/api/Workloads/CreateApproveWorkloadEmail/" + workloadId
    );
  },

  denyWorkload(workloadId, notes) {
    return axios.post("/api/Workloads/DenyWorkload", {
      workloadId: workloadId,
      notes: notes
    });
  },

  createDenyWorkloadEmail(workloadId) {
    return axios.post("/api/Workloads/CreateDenyWorkloadEmail/" + workloadId);
  }
};
